var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26079(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26079",
    "data-name": "Group 26079",
    transform: "translate(0.363 0.339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11962",
    "data-name": "Rectangle 11962",
    width: 24,
    height: 24,
    transform: "translate(-0.363 -0.339)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Search",
    d: "M583.739,2029.739a.875.875,0,0,1-1.235,0l-2.749-2.75a6.112,6.112,0,1,1,1.234-1.235l2.75,2.75a.874.874,0,0,1,0,1.234m-4.54-10.714a4.365,4.365,0,1,0,0,6.174,4.365,4.365,0,0,0,0-6.174",
    transform: "translate(-565.335 -2011.335)",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26079);
export default __webpack_public_path__ + "static/media/Group 26079.75b93592e0ec2ce41f6c7a1ad1eacafb.svg";
export { ForwardRef as ReactComponent };